import {SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const PriceAndBrandHorizontalLoading: React.FC<{
  className?: string;
  style?: React.CSSProperties;
  hideBrandLogo?: boolean;
}> = ({className, style, hideBrandLogo}) => {
  return (
    <Wrapper className={className} style={style}>
      <SkeletonBlock $width="30%" $height="30px" />
      {!hideBrandLogo && <SkeletonBlock $width="35%" $height="42px" />}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
